module.exports = __webpack_public_path__ + "img/banc-inside.b48f4750.jpg";